// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2hN6x","inputWrap":"Table_inputWrap__3DAzj","col":"Table_col__1GnPQ","bmiTooltip":"Table_bmiTooltip__3zYV8"};